module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ed-Ga.0df3c10e.png";